import { Alert, Box, Button, Typography } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { GqlMedia } from "~/__generated__";
import PhotoUploadDialog from "~/modules/media/components/PhotoUploadDialog";

import { ME_GET_USER_INFO } from "../../../auth/api/useMeGetUserInfoQuery";
import { USER_GET_BY_ID } from "../../api/useUserGetById";
import useUserUpdate from "../../api/useUserUpdate";
import UserBadge from "../UserBadge";

type ProfilePhotoUploaderUserData = {
    id: string;
    firstName: string;
    lastName: string;
    profilePictureMedia?: {
        url?: string | null;
    } | null;
};

type Props = {
    user: ProfilePhotoUploaderUserData;
};

export default function ProfilePhotoUploader({ user }: Props) {
    const { t } = useTranslation("user");
    const [isOpen, setIsOpen] = useState(false);
    const { updateUser, error } = useUserUpdate(user.id, [ME_GET_USER_INFO, USER_GET_BY_ID]);

    return (
        <Box sx={{ mb: 5 }} display="flex" flexDirection="column" alignItems="center" gap={2}>
            {error && (
                <Alert severity="error">
                    <Typography>{error.message}</Typography>
                </Alert>
            )}
            <UserBadge profilePicture={user.profilePictureMedia?.url} size={100} names={[user.firstName, user.lastName]} />
            <PhotoUploadDialog
                title={t("profilePhotoUploader.title")}
                open={isOpen}
                onClose={() => setIsOpen(false)}
                onFinished={async (mediaItem: GqlMedia) => {
                    await updateUser({
                        profilePictureId: mediaItem.id,
                    });
                    setIsOpen(false);
                }}
            />
            <Button variant="contained" onClick={() => setIsOpen(true)}>
                {user.profilePictureMedia?.url
                    ? t("profilePhotoUploader.labelChangePhoto")
                    : t("profilePhotoUploader.labelUploadPhoto")}
            </Button>
            <Typography variant="caption" color="textSecondary">
                {t("profilePhotoUploader.labelAllowedFormats")}
            </Typography>
        </Box>
    );
}
